import React, { useEffect, useState, useRef } from 'react';
import ProviderList from '../providerList';
import ProviderMap from '../providerMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import L from 'leaflet';

import './dev.css';
import logo_ds from '../../img/logo_ds_negro.png';
import { useBreakpoints } from '../hooks';
import { Spinner, Modal, Button, Alert } from "react-bootstrap";
import { ProviderDto, PagedList, ProviderSearchParamsDto, ProviderAuxiliaryDataDto } from '../../models';
import { DevContext } from '../context';
import ProviderDetail from '../providerDetail';
import FilterHeader from '../filterHeader';
import API from '../../lib/devApi';
import PritsHeader from '../pritsHeader';

export default function Dev() {
    // console.log(window.innerWidth);
    // Math.floor(window.innerWidth / 8) * 4
    const [listContainerWidth, setListContainerWidth] = useState(630);
    const [vPHeight, setVPHeight] = useState(window.innerHeight);
    const [vPWidth, setVPWidth] = useState(window.innerWidth);
    const [providers, setProviders] = useState<PagedList<ProviderDto>>();
    const [showLoading, setShowLoading] = useState(false);
    const [showDescriptionModal, setShowDescriptionModal] = useState(true);
    const [providerAuxiliaryData, setProviderAuxiliaryData] = useState<ProviderAuxiliaryDataDto>();

    const [currentPageSize, setCurrentPageSize] = useState(0);
    const [currentPageNumber, setCurrentPageNumber] = useState(0);
    const [providerSearchParams, setProviderSearchParams] = useState<ProviderSearchParamsDto>({
        name: "",
        municipalityId: null,
        startTime: null,
        endTime: null,
        pageNumber: currentPageNumber,
        pageSize: currentPageSize
    });

    const [selectedProvider, setSelectedProvider] = useState();

    const mapRef = useRef<L.Map>();

    // useEffect(() => {
    //     if(!window.onresize) {
    //         window.onresize = () => {
    //             setVPHeight(window.innerHeight);
    //             setListContainerWidth(Math.floor(window.innerWidth / 2));
    //             setVPWidth(window.innerWidth);
    //         }
    //     }
    // }, []);

    useEffect(() => {
        
        (async () => {
            try {
                setShowLoading(true);
                const result = await API.GetProviders(providerSearchParams);
                setProviders(result);
                setTimeout(() => setShowLoading(false), 1000);
            } catch (error: any) {
                console.log(error);
                setShowLoading(false);
            }
            finally {
                
            }
        })()


    }, [providerSearchParams]);

    const closeDescriptionModal = () => {
        setShowDescriptionModal(false);
    }

    const setMapContext = (map: L.Map) => {
        mapRef.current = map;
    }

    const _setSelectedProvider = (provider: any) => {
        setSelectedProvider(provider);
    }

    const AppContainer = () => {
        const breakpoint = useBreakpoints();

        let appContainer: React.ReactNode;

        switch(breakpoint) {
            case "xs":
            case "sm":
            case "md":
                // Mobile app
                appContainer = (
                    <div className='app-container' style={{height: vPHeight}}>
                        <div className='mobile-input-container'>
                            <FilterHeader />
                        </div>
                        <div style={{position: "absolute", zIndex: "1", width: "100%"}}>
                            <ProviderDetail />
                        </div>
                        {/* style={{position: "absolute", marginTop: (vPHeight - 150), zIndex: 1, backgroundColor: "white"}} */}
                        {/* (vPHeight - 260) */}
                        {/* (vPHeight/2) */}
                        {/* (vPHeight/1.30) */}
                        {
                            !selectedProvider?
                                <div style={{position: "absolute", marginTop: (vPWidth >= 1080? 0 : (vPHeight/1.35)), zIndex: 1}}>
                                    <ProviderList />
                                </div>
                            : <></>
                        }
                        <div style={{ zIndex: 0, position: "relative", height: "100%"}}>
                            <ProviderMap />
                        </div>
                        
                    </div>
                )
                break;
            case "lg":
            case "xl":
            case "xxl":
                // Desktop app
                appContainer = (
                    <div className='app-container'>
                        {/* width: listContainerWidth,  */}
                        <div style={{width: listContainerWidth, padding: "0 0 0 10px", borderRight: "1px solid #00000029", backgroundColor: "white"}}>
                            {!selectedProvider? 
                                <>
                                    <FilterHeader/>
                                    <ProviderList />
                                    {/* <FilterHeader /> */}
                                </>
                                : <ProviderDetail />
                            }
                        </div>
                        <div style={{zIndex: 0, position: "sticky", top: 0, height: "100vh"}}>
                            <ProviderMap />
                        </div>
                    </div>
                )
                break;
        }

        return appContainer;
    }

    return (
        <React.Fragment>
            {showLoading? 
                <div id="loading" className='loading-bg'>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                        <div style={{marginTop: "300px"}}>
                            <Spinner animation="grow" style={{color: "#fcba03"}} role="status" aria-hidden="true" />
                            <Spinner animation="grow" style={{color: "#fcba03"}} role="status" aria-hidden="true" />
                            <Spinner animation="grow" style={{color: "#fcba03"}} role="status" aria-hidden="true" />
                        </div>
                    </div>
                </div> : <></>
            }
            <PritsHeader />
            <div id="appHeader" className='app-header-container'>
                <div className='app-header-item'>
                    <h1 className="app-header-title">Directorio Electr&oacute;nico de Vacunaci&oacute;n</h1>
                </div>
                <div className='app-header-item' style={{textAlign: "center"}}>
                    <a href='https://www.salud.gov.pr/'>
                        <img src={logo_ds} className='app-header-img' />
                    </a>
                </div>
            </div>
            <div style={{width: "100%", height: 1, backgroundColor: "#819384"}}></div>
            <div style={{zIndex: -1}}>
                <DevContext.Provider value={{mapContext: mapRef, setMapContext, selectedProvider, setSelectedProvider: _setSelectedProvider, providers, setProviders,
                    showLoading, setShowLoading, providerSearchParams, setProviderSearchParams, providerAuxiliaryData, setProviderAuxiliaryData}}>
                    <AppContainer />
                </DevContext.Provider>
            </div>
            <Modal show={showDescriptionModal} onHide={closeDescriptionModal}>
                <Modal.Header closeButton>
                    <h2>Bienvenidos al directorio electr&oacute;nico de vacunaci&oacute;n</h2>
                </Modal.Header>
                <Modal.Body>
                    <p style={{textAlign: "justify"}}>
                        Saludos, este directorio contiene la lista de todos los proveedores de vacunaci&oacute;n contra el COVID-19 en Puerto Rico. Adicional a eso podr&aacute;
                        encontrar el resto de la oferta de vacunaci&oacute;n disponible en estos proveedores.
                    </p>
                    <Alert variant='warning'>
                        <h4>Nota importante:</h4>
                        <p>En este listado no se incluyen los proveedores de vacunación de farmacias de cadena: Walmart, CVS, Costco, Sams y Walgreens.</p>
                        <p><FontAwesomeIcon icon={faGlobe} /> Para más información de estos proveedores acceda a:</p>
                        <ul>
                            <li>
                                <a target="_blank" href="https://es.cvs.com/">Farmacias CVS</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://costco.com/">Farmacias Costco</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://walgreens.com/">Farmacias Walgreens</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://sams.com/">Farmacias Sams</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://walmart.com/">Farmacias Walmart</a>
                            </li>
                        </ul>
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={closeDescriptionModal}>
                    Cerrar
                </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
        
    )
}